import { ApolloClient, InMemoryCache, createHttpLink, ApolloLink } from '@apollo/client/core'

// Supprimer les avertissements de dépréciation en mode développement
if (import.meta.env.DEV) {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (args[0]?.includes('getLastResult') || args[0]?.includes('ObservableQuery')) {
      return; // Ignorer les avertissements Apollo spécifiques
    }
    originalWarn.apply(console, args);
  };
}

// Résoudre l'endpoint GraphQL en utilisant la variable d'environnement VITE_GRAPHQL_URL
// fallback vers localhost si la variable n'est pas définie.
const GRAPHQL_URI = (import.meta.env.VITE_GRAPHQL_URL as string) || 'http://localhost:4000/graphql'

// Afficher l'endpoint en mode développement pour débogage
if (import.meta.env.DEV) {
  console.info(`GraphQL endpoint: ${GRAPHQL_URI}`)
}

// Configuration du lien HTTP vers le serveur GraphQL
const httpLink = createHttpLink({
  uri: GRAPHQL_URI,
})

// Lien d'authentification pour ajouter le token aux requêtes
const authLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('auth-token')
  
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
    },
  })
  
  return forward(operation)
})

// Configuration du client Apollo
export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    // Optimiser la gestion du cache pour éviter les avertissements
    typePolicies: {
      Query: {
        fields: {
          // Configuration des champs pour éviter les avertissements de cache
        }
      },
      // Les reactions sont remplacees en entier a chaque evenement : la
      // reaction d un employe peut disparaitre ou changer d emoji. Sans ce
      // merge, Apollo signale une perte de donnees et le cache peut melanger
      // un ancien etat avec le nouveau.
      ChatMessage: {
        fields: {
          reactions: {
            keyArgs: false,
            merge: (_existing, incoming) => incoming,
          },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
      notifyOnNetworkStatusChange: true,
    },
    query: {
      fetchPolicy: 'cache-first',
      errorPolicy: 'all',
    },
  },
})